import router from '@/router';

export const STATUS_DICT: any = {
	WAIT: [ '待配置', 0 ],
	UN_START: [ '待启动', 4 ],
	RUNNING: [ '进行中', 1 ],
	PAUSED: [ '已暂停', 2 ],
	FINISHED: [ '已结束', 3 ],
	ABANDON: [ '已废弃', 5 ],
};

export const TYPE_OF_LAUNCH_DICT: any = {
	ACTIVITY_NAME: [ '活动名称', 0 ],
	APP_NAME: [ '应用名称', 1 ],
};

export const TYPE_OF_CHANNEL_DICT: any = {
	MEMBER_ID: [ '会员ID', 0 ],
	MOBILE: [ '手机号', 1 ],
};

export const CHANNEL_STATUS_DICT: any = {
	WAIT: [ '平台待审核', 0 ],
	REJECT_PLATFORM: [ '平台驳回', 1 ],
	PENDING: [ '媒体方审核中', 2 ],
	REJECT_MEDIA: [ '媒体方审核未通过', 3 ],
	RESOLVE: [ '审核已通过', 4 ],
	LAUNCHED: [ '投放中', 5 ],
	PAUSED: [ '暂停', 6 ],
	FINISHED: [ '投放结束', 7 ],
};

export default {
	state:
		{
			countTotal: 0,
			countOnline: 0,
			list: [],
			groupList: [],
			appList: [],
			infoId: '',
			infoName: '',
			infoStatus: '',
			infoStatusDesc: '',
			infoGroupId: '',
			infoGroupName: '',
			infoStart: '',
			infoEnd: '',
			infoDateFmt: '',
			infoAppId: '',
			infoAppName: '',
			infoAppUrl: '',
			infoBatchList: [],
			infoRecordList: [],
			infoChannelId: '',
		},
	getters:
		{
			COLOR_ACTIVITY () {
				return '#0000ff';
			},
			COLOR_EVENT () {
				return '#ff0000';
			},
			STATUS (state: any) {
				return Object.entries(STATUS_DICT).map((item: Array<any>) => {
					return { label: item[1][0], value: item[1][1] };
				});
			},
			STATUS_VALUE (state: any) {
				return router.app.$parseDict(STATUS_DICT, 1);
			},
			TYPE_OF_LAUNCH (state: any) {
				return Object.entries(TYPE_OF_LAUNCH_DICT).map((item: Array<any>) => {
					return { label: item[1][0], value: item[1][1] };
				});
			},
			TYPE_OF_LAUNCH_VALUE (state: any) {
				return router.app.$parseDict(TYPE_OF_LAUNCH_DICT, 1);
			},
			TYPE_OF_CHANNEL (state: any) {
				return Object.entries(TYPE_OF_CHANNEL_DICT).map((item: Array<any>) => {
					return { label: item[1][0], value: item[1][1] };
				});
			},
			TYPE_OF_CHANNEL_VALUE (state: any) {
				return router.app.$parseDict(TYPE_OF_CHANNEL_DICT, 1);
			},
			CHANNEL_STATUS (state: any) {
				return Object.entries(CHANNEL_STATUS_DICT).map((item: Array<any>) => {
					return { label: item[1][0], value: item[1][1] };
				});
			},
			CHANNEL_STATUS_VALUE (state: any) {
				return router.app.$parseDict(CHANNEL_STATUS_DICT, 1);
			},
		},
	mutations:
		{
			setList (state: any, { list, total }: any) {
				state.list = [ ...(list || []), { total } ];
			},
			setCount (state: any, { total, online }: any) {
				state.countTotal = total;
				state.countOnline = online;
			},
			setGrouppList (state: any, list: Array<any>) {
				state.groupList = list;
			},
			setInfoId (state: any, id: string) {
				state.infoId = id;
			},
			setInfo (state: any, data: any) {
				state.infoId = data.activityId;
				state.infoName = data.activityName;
				state.infoStatus = data.activityStatus;
				state.infoStatusDesc = data.activityStatusDesc;
				state.infoGroupId = data.activityGroupId;
				state.infoGroupName = data.activityGroupName;
				state.infoStart = data.activityStartDate;
				state.infoEnd = data.activityEndDate;
				state.infoDateFmt = data.activityDateFmt;
				state.infoAppId = data.appId;
				state.infoAppName = data.appName;
				state.infoAppUrl = data.appUrl;
			},
			setActivityBatchList (state: any, { list, total }: any) {
				state.infoBatchList = [ ...(list || []), { total } ];
			},
			setActivityRecordList (state: any, { list, total }: any) {
				state.infoRecordList = [ ...(list || []), { total } ];
			},
			setActivityChannelId (state: any, id: any) {
				state.infoChannelId = id;
			},
			setActivityChannelRecordList (state: any, { list, total, index }: any) {
				state.infoRecordList[index].list = [ ...(list || []), { total } ];
			},
		},
	actions:
		{
			async getCalendarList ({ commit, state, getters, dispatch, rootState }: any, params: any) {
				commit('setList', { list: [], total: 0 });
				const { error, success }: any = await router.app.$request('CALENDAR_LIST', params);
				if (success) {
					let list = [
						...(success.data.activityList || []).map((item: any) => {
							item.activityId = item.id;
							item.eventLoop = item.eventLoop || 0;
							item.color = item.color || getters.COLOR_ACTIVITY;
							return item;
						}),
						...(success.data.eventList || []).map((item: any) => {
							item.eventLoop = item.eventLoop || 0;
							item.color = item.color || getters.COLOR_EVENT;
							return item;
						}),
					];
					commit('setList', { list, total: list.length });
				}
				return { error, success };
			},
			async getCalendarInfo ({ commit, state, dispatch, rootState }: any, params: any) {
				const { error, success }: any = await router.app.$request('CALENDAR_INFO', params);
				return { error, success };
			},
			async addCalendar ({ commit, state, dispatch, rootState }: any, params: any) {
				const { error, success }: any = await router.app.$request('CALENDAR_ADD', params);
				/* if (success) {
					commit('setList', success.data);
				} */
				return { error, success };
			},
			async updateCalendar ({ commit, state, dispatch, rootState }: any, params: any) {
				const { error, success }: any = await router.app.$request('CALENDAR_UPDATE', params);
				/* if (success) {
					commit('setList', success.data);
				} */
				return { error, success };
			},
			async removeCalendar ({ commit, state, dispatch, rootState }: any, params: any) {
				const { error, success }: any = await router.app.$request('CALENDAR_REMOVE', params);
				/* if (success) {
					commit('setList', success.data);
				} */
				return { error, success };
			},
			async getActivityList ({ commit, state, dispatch, rootState }: any, params: any) {
				commit('setList', { list: [], total: 0 });
				const { error, success }: any = await router.app.$request('ACTIVITY_LIST', params);
				if (success) {
					success.data.list = (success.data.list || []).map((item: any) => {
						item.activityDateFmt = [
							router.app.$format(item.activityStartDate) + ' 至 2099-12-31',
							router.app.$format(item.activityStartDate) +
								' 至 ' +
								router.app.$format(item.activityEndDate),
						][Number(item.activityType)];
						return item;
					});
					commit('setList', success.data);
				}
				return { error, success };
			},
			async updateActivityAllPause ({ commit }: any) {
				const { error, success }: any = await router.app.$request('ACTIVITY_PUASE_ALL');
				return { error, success };
			},
			async getActivityCountTotal ({ commit }: any) {
				const { error, success }: any = await router.app.$request('ACTIVITY_COUNT_TOTAL');
				if (success) {
					commit('setCount', {
						total: success.data.activityTotalNum,
						online: success.data.activityOnlineNum,
					});
				}
			},
			async updateActivityStatus ({ commit, state, dispatch, rootState }: any, params: any) {
				const { error, success }: any = await router.app.$request('ACTIVITY_STATUS_UPDATE', params);
				return { error, success };
			},
			async getActivityGroupList ({ commit, state, dispatch, rootState }: any) {
				const { error, success }: any = await router.app.$request('ACTIVITY_GROUP_LIST', {
					pageNum: 1,
					pageSize: 999,
				});
				if (success) {
					commit(
						'setGrouppList',
						success.data.map((item: any) => {
							return {
								label: item.groupName,
								value: item.id,
								count: item.activityCount,
							};
						}),
					);
				}
				return { error, success };
			},
			async getAcitvityInfo ({ commit, state, dispatch, rootState }: any, params: any = {}) {
				dispatch('getActivityGroupList');
				params.activityId = params.activityId || state.infoId;
				const { error, success }: any = await router.app.$request('ACTIVITY_INFO', params);
				if (success) {
					success.data.activityDateFmt = [
						router.app.$format(success.data.activityStartDate) + ' 至 2099-12-31',
						router.app.$format(success.data.activityStartDate) +
							' 至 ' +
							router.app.$format(success.data.activityEndDate),
					][Number(success.data.activityType)];
					commit('setInfo', success.data);
				}
				return { error, success };
			},
			async getActivityStatusList ({ commit, state, dispatch, rootState }: any, params: any) {
				const { error, success }: any = await router.app.$request('ACTIVITY_LIST');
				if (success) {
					commit('setHot', success.data);
				}
				return { error, success };
			},
			async addActivityGroup ({ commit, state, dispatch, rootState }: any, params: any) {
				const { error, success }: any = await router.app.$request('ACTIVITY_GROUP_ADD', params);
				if (success) {
					dispatch('getActivityGroupList');
				}
				return { error, success };
			},
			async removeActivityGroup ({ commit, state, dispatch, rootState }: any, params: any) {
				const { error, success }: any = await router.app.$request('ACTIVITY_GROUP_REMOVE', params);
				if (success) {
					dispatch('getActivityGroupList');
				}
				return { error, success };
			},
			async assignActivityGroup ({ commit, state, dispatch, rootState }: any, params: any) {
				const { error, success }: any = await router.app.$request('ACTIVITY_GROUP_ASSIGN', params);
				return { error, success };
			},
			async getCouponBatchList ({ commit, state, dispatch, rootState }: any, params: any) {
				commit('setActivityBatchList', { list: [], total: 0 });
				const { error, success }: any = await router.app.$request('COUPON_LAUNCH_LIST', params);
				if (success) {
					success.data.list = (success.data.list || []).map((item: any) => {
						item.checked = false;
						item.couponEffectiveDateFmt = [
							[
								router.app.$format(item.couponEffectiveStartTime),
								router.app.$format(item.couponEffectiveEndTime),
							].join('至'),
							item.couponActivedLimitedStartDay == 0 && item.couponActivedLimitedDays == 1
								? '仅当天有效'
								: (item.couponActivedLimitedStartDay == 0
										? '领取后当天开始(含当天)有效'
										: '领取后' +
											(item.couponActivedLimitedStartDay + 1 > 0
												? '第' + (item.couponActivedLimitedStartDay + 1) + '天开始(含当天)有效'
												: '当天开始有效')) +
									', 有效期' +
									item.couponActivedLimitedDays +
									'天',
							[
								router.app.$format(item.couponGetStartTime),
								router.app.$format(item.couponGetEndTime),
							].join('至'),
						][item.couponEffectiveSwitch];
						return item;
					});
					commit('setActivityBatchList', success.data);
				}
				return { error, success };
			},
			async getLaunchList ({ commit, state, dispatch, rootState }: any, params: any) {
				commit('setActivityRecordList', { list: [], total: 0 });
				params.businessEntityId = router.app.$global.tenantId;
				const { error, success }: any = await router.app.$request('COUPON_LAUNCH_LIST', params);
				if (success) {
					success.data.list = (success.data.list || []).map((item: any) => {
						item.pourNum = (router.app as any).$thousand(item.pourNum);
						item.getQuantity = (router.app as any).$thousand(item.getQuantity);
						item.effectiveQuantity = (router.app as any).$thousand(item.effectiveQuantity);
						item.couponEffectiveDateFmt = [
							[
								router.app.$format(item.couponEffectiveStartTime),
								router.app.$format(item.couponEffectiveEndTime),
							].join('至'),
							item.couponActivedLimitedStartDay == 0 && item.couponActivedLimitedDays == 1
								? '仅当天有效'
								: (item.couponActivedLimitedStartDay == 0
										? '领取后当天开始(含当天)有效'
										: '领取后' +
											(item.couponActivedLimitedStartDay + 1 > 0
												? '第' + (item.couponActivedLimitedStartDay + 1) + '天开始(含当天)有效'
												: '当天开始有效')) +
									', 有效期' +
									item.couponActivedLimitedDays +
									'天',
							[
								router.app.$format(item.couponGetStartTime),
								router.app.$format(item.couponGetEndTime),
							].join('至'),
						][item.couponEffectiveSwitch];
						return item;
					});
					commit('setActivityRecordList', success.data);
				}
				return { error, success };
			},
			async getEffectiveList ({ commit, state, dispatch, rootState }: any, params: any) {
				commit('setActivityRecordList', { list: [], total: 0 });
				const { error, success }: any = await router.app.$request('COUPON_ENTITY_LIST', params);
				if (success) {
					commit('setActivityRecordList', success.data);
				}
				return { error, success };
			},
			async getMemberList ({ commit, state, dispatch, rootState }: any, params: any) {
				commit('setActivityRecordList', { list: [], total: 0 });
				const { error, success }: any = await router.app.$request('ACTIVITY_INFO_MEMBER_LIST', params);
				if (success) {
					commit('setActivityRecordList', success.data);
				}
				return { error, success };
			},
			async getChannelList ({ commit, state, dispatch, rootState }: any, params: any) {
				commit('setActivityRecordList', { list: [], total: 0 });
				const { error, success }: any = await router.app.$request('ACTIVITY_INFO_CHANNEL_LIST', params);
				if (success) {
					success.data.list = (success.data.list || []).map((item: any) => {
						item.mobile = item.mobile || '-';
						item.list = [];
						return item;
					});
					commit('setActivityRecordList', success.data);
				}
				return { error, success };
			},
			async onChannel ({ commit, state, dispatch, rootState }: any) {
				const { error, success }: any = await router.app.$request('ACTIVITY_INFO_CHANNEL_UPDATE', {
					requisitionId: state.infoChannelId,
					operateAction: 'reuse',
				});
				return { error, success };
			},
			async offChannel ({ commit, state, dispatch, rootState }: any) {
				const { error, success }: any = await router.app.$request('ACTIVITY_INFO_CHANNEL_UPDATE', {
					requisitionId: state.infoChannelId,
					operateAction: 'pause',
				});
				return { error, success };
			},
			async getChannelRecordList ({ commit, state, dispatch, rootState }: any, params: any) {
				const index: number = params.index;

				commit('setActivityChannelRecordList', { list: [], total: 0, index });

				params.index = '';

				const { error, success }: any = await router.app.$request('ACTIVITY_INFO_CHANNEL_LIST_RECORD', params);
				if (success) {
					commit('setActivityChannelRecordList', { ...success.data, index });
				}
				return { error, success };
			},
			async getReportList ({ commit }: any, params: any) {
				commit('setList', { list: [], total: 0 });
				const { error, success }: any = await router.app.$request('ACTIVITY_INFO_REPORT', params);
				if (success) {
					commit('setList', success.data);
				}
				return { error, success };
			},
		},
};
